export default __webpack_public_path__ + "static/accueil-velo-09685e615b233776596cc00bfbce034c.png";